import { NgModule, importProvidersFrom, APP_INITIALIZER  } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { PrismTitleStrategy } from '@core/services/prism-title.strategy';
import { BrowserModule, provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PathInterceptorService } from '@core/interceptors/path-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FeaturesModule } from '@views/features/features.module';
import { TokenInterceptorService } from '@core/interceptors/token.interceptor';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LogInGuard } from '@core/guards/log-in-guard.guard';
import { ErrorInterceptor } from '@core/interceptors/error.Interceptor';
import { AuthService } from '@core/services/auth.service';

export function initAuth(auth: AuthService) {
  return () => auth.verifyLoginOnStart();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FeaturesModule
  ],
  providers: [
    { 
      provide: APP_INITIALIZER, 
      useFactory: initAuth, 
      deps: [AuthService], 
      multi: true 
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PathInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    provideClientHydration(withHttpTransferCacheOptions({
      includeHeaders: ['Authorization', 'Content-Type']
    })),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule),
    importProvidersFrom(HttpClientModule),
    provideAnimations(),
    LogInGuard,
    { provide: TitleStrategy, useClass: PrismTitleStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
